let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cdi9t")).then(() => parcelRequire('l04jD'));